import {
    useEffect,
    useState
} from 'react';
import { useDropzone } from 'react-dropzone'
import { Button, Card, Alert, Row, Form, Col } from 'react-bootstrap';
import Loader from '../components/Loader';
import { labels } from "../config/config"
import languages from '../config/languages.json'
import { getDataFromFile, onShowMessage } from '../utils/utils';
import { useNavigate, useOutletContext } from 'react-router-dom';


function TermSuiteImportScreen() {
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false)

    const { profileState } = useOutletContext();
    const { projectRole: { projectId } } = profileState
    const navigate = useNavigate()

    const d = new Date();

    const [lang, setLang] = useState(0)
    const [label, setLabel] = useState(`TSUIT_${d.getFullYear()}${d.getMonth() + 1}${d.getDate()}${d.getHours()}${d.getMinutes()}`)


    const maxSize = 7e+8;
    const { isDragActive, getRootProps, getInputProps, acceptedFiles, isDragReject, fileRejections } = useDropzone({
        accept: {
            'text/tab-separated-values': ['.tsv']
        },
        minSize: 0,
        maxSize
    });
    const isFileTooLarge = fileRejections.length > 0 && fileRejections[0].file.size > maxSize

    useEffect(() => {
        if (fileRejections.length > 0 || isDragReject) {
            if (isFileTooLarge) setMessage("Le fichier est trop volumineux !")
            else setMessage("Type de fichier non pris en charge")
            onShowMessage(setShowError, setMessage);
        }
    }, [fileRejections, isDragReject, isFileTooLarge])

    const Onclickbutton = () => {
        getDataFromFile(
            "termsuite",
            acceptedFiles,
            projectId,
            setIsLoading,
            setMessage,
            setShowError,
            setShowSuccess,
            { label, lang },
            false,
            navigate,
        )
    }

    const labelHandleChange = (event) => {
        setLabel(event.target.value)
    }


    return (
        <div className="container-element">
            <div className="container text-center mt-5">
                <h4 className="mb-3">Import TermSuite</h4>
                <p className="mb-3">{labels.TermSuiteImport[0]} (<a href={labels.TermSuiteImport[1]} target="_blank" rel='noopener noreferrer'>{labels.TermSuiteImport[1]}</a>) {labels.TermSuiteImport[2]}</p>

                <Alert className="mx-5" variant="success" show={showSuccess} >
                    Fichiers envoyés avec succès
                </Alert>
                <Alert className="alert-custom mx-5" variant="danger" show={showError} dismissible onClose={() => setShowError(false)}>
                    {message}
                </Alert>

                <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    {!isDragActive &&
                        <Card>
                            <Card.Body>Cliquez ici ou déposez un fichier pour l'importer !</Card.Body>
                        </Card>
                    }
                    {isDragActive && !isDragReject &&
                        <Card>
                            <Card.Body>Déposez votre fichier ici !</Card.Body>
                        </Card>
                    }
                    {isDragReject &&
                        <Card>
                            <Card.Body className="text-warning mt-2">Le type de fichier n'est pas accepté !</Card.Body>
                        </Card>
                    }
                    {isFileTooLarge && (
                        <div>
                            <div className="text-danger mt-2">Le fichier est trop volumineux !</div>
                            <div className="text-danger mt-2">La taille limite des fichiers est {maxSize / 1000000}Mo.</div>
                        </div>
                    )}
                </div>
                <ul className="list-group mt-2">
                    {acceptedFiles.length > 0 && !isFileTooLarge && acceptedFiles.map(acceptedFile => (
                        <li className="list-group-item list-group-item-success" key={acceptedFile.name}>
                            {acceptedFile.name}
                        </li>
                    ))}
                </ul>
                <Form className="mt-2 center" style={{ width: "70%" }}>
                    <Form.Group as={Row} className="mb-3" controlId="">
                        <Form.Label column sm="6" xs="12">
                            Libellé
                        </Form.Label>
                        <Col sm="6" xs="12">
                            <Form.Control
                                defaultValue={label}
                                onChange={labelHandleChange}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="">
                        <Form.Label column sm="6" xs="12">
                            Langue
                        </Form.Label>
                        <Col sm="6" xs="12">
                            <Form.Control
                                as='select'
                                value={lang}
                                onChange={(e) => setLang(e.target.value)}
                            >
                                <option value={0}>Select...</option>
                                {languages.map((language => (
                                    <option
                                        key={Object.keys(language)}
                                        value={Object.keys(language)}
                                    >{Object.values(language)}</option>
                                )))}
                            </Form.Control>
                        </Col>
                    </Form.Group>
                </Form>
                {isLoading && <div className="m-2"><Loader>Envoi des fichiers ...</Loader></div>}
                <div><Button className="mt-2" onClick={Onclickbutton}>Import</Button></div>
                <p className="m-2  mt-4">{message}</p>
            </div>
        </div>
    )
}

export default TermSuiteImportScreen
